import IDMGlobals from './../../IDMGlobals';
import IDMUtils from './../../IDMUtils';
//
const sha1 = require('sha1');
const crypto = require('crypto');

/**
* @class AppID
* @classdesc AppID Class is reponsible for encoding and decoding the AppID token hash
* and also has utlities methods for its validation.
*/
export default class AppID {

  /**
   * constructor - Initializes a new AppID with already encoded token,
   * so you should use one instance of appid per usage.
   *
   * @param  {type} appID  The appid hash if initializing the class for decoding.
   * @param  {type} token  The application token if initializng th class for encoding.
   * @param  {type} secret The application secret if initializng th class for encoding.
   */
  constructor(appID, token, secret) {
    this.verificationObject = null;
    this.hash = null;
    this.accessSecret = null;
    this.accessToken = null;
    //init with appID to decode
    if (IDMUtils.isValidString(appID)) {
      this.hash = appID;
      this._decode();
    }
    //Init with token and secret to encode
    else if (IDMUtils.isValidString(token) && IDMUtils.isValidString(secret)) {
      this.accessToken = token;
      this.accessSecret = secret;
      this.timestamp = new Date().getTime();
      this._encode();
    }
  }
  /**
   * getHash - Get current AppID hash token used with communication with the API.
   *
   * @return {string}  The AppID token hash. If initialized with the token to be decoded, hash
   * is expected to be the same value of the initialization.
   */
  getHash() { return this.hash; } //encoded app id

  /**
   * getVerificationToken - Get verification code generated by the token or by decoding the hash.
   *
   * @return {string}  The verification code hash.
   */
  getVerificationToken() { return (this.verificationObject && this.verificationObject.token ? this.verificationObject.token : null); }

  /**
   * isExpired - Check if current token is expired. Should work on both ways although is
   * useless on the encoding side.
   *
   * @return {boolean}  If the token is expired or not.
   */
  isExpired() {
    let v = false;
    try {
      const currStampDiff = (new Date().getTime() - this.verificationObject.timestamp)/1000;
      v = (currStampDiff <= IDMGlobals.AppIDTokenValidityPeriod);
    } catch(e) { }
    return !v;
  }

  /**
   * _decode - Internal decode this.hash and set internal ivars.
   * @private
   */
  _decode() {
    //decode
    let obj = null;
    try {
      //parse hash
      const p = this.hash.split(':');
      const iv = Buffer.from(p.shift(), 'hex');
      //decrypt
      const d = crypto.createDecipheriv(IDMGlobals.AppIDEncryptionAlgorithm, Buffer.from('rotativeKeyrotativeKeyrotativeKe'), iv);
      let strObj = d.update(Buffer.from(p.join(':'), 'hex'));
      strObj = Buffer.concat([strObj, d.final()]);
      //parse safely
      obj = JSON.parse(strObj.toString());
    } catch(e) {}
    //Validate
    if (obj && IDMUtils.isValidString(obj.token) && IDMUtils.isValidNumber(obj.timestamp)) this.verificationObject = obj;
  }

  /**
   * _encode - Internally encode and set the object ivars.
   * @private
   */
  _encode() {
    const verificationToken = AppID.verificationCode(this.accessToken, this.accessSecret);
    this.verificationObject = { token: verificationToken, timestamp: this.timestamp };
    const iv = crypto.randomBytes(16);
    const c = crypto.createCipheriv(IDMGlobals.AppIDEncryptionAlgorithm, Buffer.from('rotativeKeyrotativeKeyrotativeKe'), iv);
    this.hash = c.update(JSON.stringify(this.verificationObject));
    this.hash = Buffer.concat([this.hash, c.final()]);
    this.hash = iv.toString('hex') + ':' + this.hash.toString('hex');
  }
}

/**
 * verificationCode - Get verification code by token key and secret.
 *
 * @param  {string} token  description
 * @param  {string} secret description
 * @return {string}        Verificaiton code of the token key and secret.
 */
AppID.verificationCode = function(token, secret) {
  return sha1(JSON.stringify({token, secret}))
}
